import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names safely.
 *
 * `clsx` resolves conditional class expressions; `tailwind-merge` then removes
 * conflicting Tailwind utilities so the last-declared one wins.
 *
 * @example cn('px-2', condition && 'px-4') // -> 'px-4'
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
